module.exports=function(scope){ return `// Signal to the FaceTec SDK that audit trail should be captured
ZoomSDK.auditTrailType = .Height640

// Capture a User Session
let sessionVC = Zoom.sdk.createSessionVC(delegate: self)
self.present(sessionVC, animated: true, completion: nil)

// Sample code to handle the session result
func onZoomSessionResult(result: ZoomSessionResult) {
    print("Session result: \\(result.status)")

    // Session failed
    if result.status != .UserProcessedSuccessfully {
        // Handle results here
        return
    }

    if result.faceMetrics != nil {
        // Get the audit trail image(s) if available
        let auditTrail = result.faceMetrics?.auditTrail
        // Check the audit trail image count
        NSLog("Audit trail image count result: \(auditTrail.count)")
        // Get the audit trail history if available
        let auditTrailHistory = result.faceMetrics?.auditTrailHistory
    }
    // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/17-zoom-audit-trail.swift.tpl